


// import React, {
//   ChangeEvent,
//   useCallback,
//   useEffect,
//   useMemo,
//   useState,
//   useRef,
// } from 'react';
// import { FaPuzzlePiece } from "react-icons/fa6";
// import { MdOutlineSwipe } from "react-icons/md";
// import { TbDragDrop2 } from "react-icons/tb";
// import { FaChartLine } from 'react-icons/fa';
// import { FaClipboardList } from 'react-icons/fa';
// import { FaLightbulb } from "react-icons/fa";
// import { IoAlert } from "react-icons/io5";
// import { MdPsychology } from "react-icons/md";
// import { HiLink } from 'react-icons/hi';
// import { ScenarioSelection,interactionfedback } from 'utils/game/gameService';
// import {
//   Box,
//   Text,
//   Flex,
//   Button,
//   Icon,
//   List,
//   ListItem,
//   Img,
//   Textarea,
//   Input,
//   Divider,
//   Tooltip,
//   FormLabel,
//   Switch,
//   FormControl,
//   RadioGroup,
//   Stack,
//   Radio,
// } from '@chakra-ui/react';
// import Select from 'react-select';
// import {
//   MdAdd,
//   MdCloudUpload,
//   MdInbox,
//   MdNote,
//   MdNoteAdd,
//   MdTextsms,
//   MdDelete,
//   MdOutlineStickyNote2,
// } from 'react-icons/md';
// import { BiSolidDuplicate } from 'react-icons/bi';
// import Menu from '../components/Navigate';
// import StrightConector from '../components/dragNdrop/strightConector';
// import { TbHandClick, TbMessages } from 'react-icons/tb';
// import InputField from 'components/fields/InputField';
// import { SearchIcon } from '@chakra-ui/icons';
// import TextField from 'components/fields/TextField';
// import BadgeImages from '../components/BadgeImages';
// import { FaAward } from 'react-icons/fa6';
// import { MdAssessment } from "react-icons/md";
// import { MdOutlineAssessment } from "react-icons/md";
// interface PropsNote {
//   reviews?: any;
//   listBlockItems?: any;
//   id?: number;
//   formData?: any;
//   language?: any;
//   seq?: any;
//   index?: number;
//   handleNDI?: any;
//   name?: any;
//   handleInput?: any;
//   GameId?:any;
//   input?: any;
//   getSeq?: any;
//   handleMiniNDI?: any;
//   duplicateSeq?: any;
//   delSeq?: any;
//   alphabet?: any;
//   setNavigation: any;
//   handleBlock: any;
//   items?: any;
//   formDataGamelanguageCode?: any;
//   handleSelectBlock?: any;
//   showSelectBlock?: any;
//   setSelectBlock?: any;
//   validation?: any;
//   currentseq?: any;
//   ShowReview?: any;
//   targetSequence?: any;
//   blockOnFocusHanlder: any;
//   blockOnBlurHanlder: any;
//   BlockItems:any;
// }

// interface Block {
//   blockPrimarySequence: string;
//   content: string | undefined;
// }

// const ScenarioCompletionCompo: React.FC<PropsNote> = ({
//   targetSequence,
//   listBlockItems,
//   GameId,
// formData,
//   seq,
//   index,
//   name,
//   handleInput,
//   input,
//   getSeq,
//   duplicateSeq,
//   delSeq,
//   setNavigation,
//   handleBlock,
//   handleSelectBlock,
//   items,
//   showSelectBlock,
//   handleNDI,
//   validation,
//   BlockItems,
// }) => {
//   // new
//   const [interactionValue, setInteractionValue] = useState<string | null>(null);
//   const hasInitialized = useRef(false); 
//   console.log('seqseq', seq);
//   console.log('InPut from ScenarioCompletionCompo:', input);
//  const gameQuestNo =BlockItems[0].questNo;
//   const blockKey = `ScenarioCompletion${seq.input}`;
//   // const scData = input?.[blockKey] || {};
//     const scData = {
//   ...input?.[blockKey],
//   totalScore:
//     input?.[blockKey]?.totalScore ??
//     input?.[blockKey]?.scTotalScore ??
//     '',
// };

//   // const [totalScore, setTotalScore] = useState<number | null>(null);
//   // const [minPassScore, setMinPassScore] = useState<number | null>(null);
//   const blockItemsArray = useMemo(() => {
//     if (Array.isArray(listBlockItems)) return listBlockItems;

//     if (listBlockItems && typeof listBlockItems === "object") {
//       return Object.values(listBlockItems);
//     }

//     return [];
//   }, [listBlockItems]);

//   /* new logic*/
//   const selectedItem = useMemo(() => {
//     return blockItemsArray.find(
//       (item: any) =>
//         item.id === seq.id &&
//         item.questNo === seq.questNo &&
//         item.input === seq.input &&
//         item.type === seq.type
//     );
//   }, [blockItemsArray, seq]);

//   // new
//   useEffect(() => {
//     if (interactionValue === null) {
//       const backendValue =
//         selectedItem?.interactionfeedback ||
//         input?.[`ScenarioCompletion${seq.input}`]?.interactionfeedback;

//       if (backendValue) {
//         setInteractionValue(backendValue);
//         hasInitialized.current = true;
//       }
//     }
//   }, [selectedItem, input, seq.input]);
//   // const [distinctionScore, setDistinctionScore] = useState<number | null>(null);
//   // const [screenTitle, setScreenTitle] = useState<string | null>(null);
//   // const [singleCongrats, setSingleCongrats] = useState<string | null>(null);
//   // const [belowMinMsg, setBelowMinMsg] = useState<string | null>(null);
//   // const [aboveMinMsg, setAboveMinMsg] = useState<string | null>(null);
//   // const [aboveDistinctionMsg, setAboveDistinctionMsg] = useState<string | null>(null);
//   // const [showMinPass, setShowMinPass] = useState(false);
//   // const [showDistinction, setShowDistinction] = useState(false);
//   // const [showBadge, setShowBadge] = useState(false);
//   // const [showCongrats, setShowCongrats] = useState(false);
//   // const [bagdgeCriteria, setBadgeCriteria] = useState(false);
//   // const [isSingleCongrats, setIsSingleCongrats] = useState(true);
//   // const [isScoreWiseCongrats, setIsScoreWiseCongrats] = useState(false);

//   // const textareaRef = useRef(null);


//   const hasScoreLogic =
//     scData.scMinPassEnabled === 'true' ||
//     scData.scDistinctionEnabled === 'true';

//   const congratsMode = scData.scCongratsMode ?? 'Single';


//   // shiw interaction feedback options
//   const options = [
//     { value: 'Each', name: 'Immediately After Each Interaction' },
//     { value: 'Completion', name: ' Together After Completion Screen' },
//   ];

//   // basic / complex options
// //   const scenarioLevelOptions = [
// //     { value: 'basic', label: 'Basic' },
// //     { value: 'complex', label: 'Complex' },
// //   ];

//   const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
//   label: `Scenario ${i + 1}`,
//   value: `Scenario ${i + 1}`,
// }));

 

 
//   const customStyles = {
//     menuPortal: (base: any) => ({
//       ...base,
//       zIndex: 9999
//     }),
//     control: (provided: any, state: any) => ({
//       ...provided,
//       borderRadius: '15px',
//       borderColor: 'inherit',
//       background: 'transparent',
//       // height: '45px',
//       width: '130px',
//       padding: '0 !important',
//     }),
//   };
//   const gameId = GameId
// //  const gameQuestNo = formData.gameQuestNo;
//   console.log('formDataformDataformDatainapi', gameQuestNo);
//   const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
//     handleNDI(value);
//     const maxInputItem = items.reduce(
//       (max: any, item: any) => (item.input > max.input ? item : max),
//       items[0],
//     );
//     let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
//     if (value !== '') {
//       handleSelectBlock(
//         { value: input },
//         input,
//         `ScenarioCompletion${seq.input}`,
//         `ScenarioCompletion${seq.input}`,
//       );
//     }
//   };

//   const MiniBox1 = (props: { seq?: any; i?: number; name?: any; bodyRef?: any }) => {
//     const { seq, i, name, bodyRef } = props;
//     return (
//       <Box
//         position={'relative'}
//         background={'#fff'}
//         p={'10px'}
//         boxShadow={'1px 1px 17px #69627914'}
//         borderRadius={'8px'}
//         zIndex={99}
//         className="MiniShowBox"
//       >
//         <List cursor={'pointer'}>
//                  <ListItem
//                    onClick={() => handleMiniNDInewblock('Note', seq, i)}
//                    p={'10px'}
//                    display={'flex'}
//                    alignItems={'center'}
//                    borderBottom={'2px solid #f1f1f170'}
//                  >
//                    <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
//                    Note
//                  </ListItem>
       
//                  <ListItem
//                    onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
//                    p={'10px'}
//                    display={'flex'}
//                    alignItems={'center'}
//                    borderBottom={'2px solid #f1f1f170'}
//                  >
//                    <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
//                    Dialog
//                  </ListItem>
//                  <ListItem
//                    onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
//                    p={'10px'}
//                    display={'flex'}
//                    alignItems={'center'}
//                  >
//                    <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
//                    Interaction
//                  </ListItem>
//                  <ListItem
//                    onClick={() => handleMiniNDInewblock('Link', seq, i)}
//                    p={'10px'}
//                    display={'flex'}
//                    alignItems={'center'}
//                    borderBottom={'2px solid #f1f1f170'}
//                  >
//                    <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
//                    Link
//                  </ListItem>
                 
//                    <>
//                      <ListItem
//                        onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
//                        p={'10px'}
//                        display={'flex'}
//                        alignItems={'center'}
//                        borderBottom={'2px solid #f1f1f170'}
//                      >
//                        <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
//                        Reflection
//                      </ListItem>
       
//                      <ListItem
//                        onClick={() => handleMiniNDInewblock('Overview', seq, i)}
//                        p={'10px'}
//                        display={'flex'}
//                        alignItems={'center'}
//                        borderBottom={'2px solid #f1f1f170'}
//                      >
//                        <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
//                        Overview
//                      </ListItem>
//                      <ListItem
//                        onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
//                        p={'10px'}
//                        display={'flex'}
//                        alignItems={'center'}
//                        borderBottom={'2px solid #f1f1f170'}
//                      >
//                        <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
//                        KeyInsights
//                      </ListItem>
//                      <ListItem
//                        onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
//                        p={'10px'}
//                        display={'flex'}
//                        alignItems={'center'}
//                        borderBottom={'2px solid #f1f1f170'}
//                      >
//                        <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
//                        PreAssessment
//                      </ListItem>
//                      <ListItem
//                        onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
//                        p={'10px'}
//                        display={'flex'}
//                        alignItems={'center'}
//                        borderBottom={'2px solid #f1f1f170'}
//                      >
//                        <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
//                        PostAssessment
//                      </ListItem>
//                        <ListItem
//                                                              onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
//                                                              p={'10px'}
//                                                              display={'flex'}
//                                                              alignItems={'center'}
//                                                              borderBottom={'2px solid #f1f1f170'}
//                                                            >
//                                                              <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
//                                                              WehaveChoose
//                                                            </ListItem>
//                                                                       <ListItem
//                                                              onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
//                                                              p={'10px'}
//                                                              display={'flex'}
//                                                              alignItems={'center'}
//                                                              borderBottom={'2px solid #f1f1f170'}
//                                                            >
//                                                              <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
//                                                              Swipe
//                                                            </ListItem>
//                                                                       <ListItem
//                                                              onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
//                                                              p={'10px'}
//                                                              display={'flex'}
//                                                              alignItems={'center'}
//                                                              borderBottom={'2px solid #f1f1f170'}
//                                                            >
//                                                              <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
//                                                              Drag For Now 
//                                                            </ListItem>
                     
//                    </>
                
//                  {formData?.gameScenarioCompletion === 'true' && (
//                    <ListItem
//                      onClick={() =>
//                        handleMiniNDInewblock('ScenarioCompletion', seq, i)
//                      }
//                      p={'10px'}
//                      display={'flex'}
//                      alignItems={'center'}
//                      borderBottom={'2px solid #f1f1f170'}
//                    >
//                      <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
//                      ScenarioCompletion
//                    </ListItem>
//                  )}
//                </List>
//       </Box>
//     );
//   };

//   let focusSeqRef: any;
//   const justClick = (event: any, seq: any) => {
//     if (event.type === 'click') {
//       focusSeqRef = document.getElementsByClassName(seq.id);
//       const element = focusSeqRef?.[0];
//       if (element) {
//         element.classList.remove('non-caret');
//         element.removeAttribute('readonly');
//         element.focus();
//       }
//     }
//   };
// // const handleScenarioChange = async (option: any) => {
// //   const selectedScenario = option?.value; // e.g. "Scenario 1"

// //   // update local state
// //   handleInput({
// //     name: `ScenarioCompletion${seq.input}`,
// //     value: {
// //       scenario: selectedScenario,
// //     },
// //   });

// //   // call backend
// //   try {
// //     const response = await ScenarioSelection(gameId, selectedScenario);
// //     console.log("Scenario API response:", response);
// //   } catch (error) {
// //     console.error("Failed to send scenario", error);
// //   }
// // };
//   const handleScenarioChanges = async (
//     data: any,
//     source: "scenario" | "interaction"
//   ) => {
//     const prev = input?.[`ScenarioCompletion${seq.input}`] || {};

//     const updatedValue = {
//       scenario:
//         source === "scenario" ? data?.value : prev.scenario,
//       interactionfeedback:
//         source === "interaction" ? data.target.value : prev.interactionfeedback,
//     };

//     // update local state
//     handleInput({
//       name: `ScenarioCompletion${seq.input}`,
//       value: updatedValue,
//     });

//     // call API ONLY when both values exist
//     if (updatedValue.scenario && updatedValue.interactionfeedback) {
//       try {
//         const response = await interactionfedback(
//           gameId,
//           gameQuestNo,
//           updatedValue.scenario,
//           updatedValue.interactionfeedback
//         );
//         console.log("Scenario API response:", response);
//       } catch (error) {
//         console.error("Failed to send scenario", error);
//       }
//     }
//   };

// const handleScenarioChange = async (option: any) => {
//   const selectedScenario = option?.value;

//   // update selected scenario
//   handleInput({
//     name: `ScenarioCompletion${seq.input}`,
//     value: {
//       scenario: selectedScenario,
//     },
//   });

//   try {
//     const response = await ScenarioSelection(gameId, selectedScenario);
//     console.log("Scenario API response:", response);

//     if (response?.success) {
//       // ✅ set total score from backend
//       handleSCChange("totalScore", response.totalScore);
//     }
//   } catch (error) {
//     console.error("Failed to send scenario", error);
//   }
// };


//   const handleSCChange = (field: string, value: any) => {
//     handleInput(
//       {
//         target: {
//           name: `ScenarioCompletion${seq.input}`,
//           id: field,
//           value,
//         },
//       },
//       index,
//       seq.input,
//     );
//   };

//   return (
//     <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
//       <Box className="block-action-icons">
//         <Tooltip hasArrow label="Choose New Block">
//           <div>
//             <Icon
//               as={MdAdd}
//               transitionDelay={'0s !important'}
//               fontSize={'18px'}
//               color={'grey'}
//               mr={'10px'}
//               cursor={'pointer'}
//               onClick={() => getSeq(seq, index, name)}
//             />
//           </div>
//         </Tooltip>
//         <Tooltip hasArrow label="Duplicate">
//           <div>
//             <Icon
//               as={BiSolidDuplicate}
//               transitionDelay={'0.1s !important'}
//               fontSize={'18px'}
//               color={'grey'}
//               mr={'10px'}
//               cursor={'pointer'}
//               onClick={() =>
//                 duplicateSeq(seq, index, name, input?.[`ScenarioCompletion${seq.input}`])
//               }
//             />
//           </div>
//         </Tooltip>
//         <Tooltip hasArrow label="Delete ScenarioCompletion">
//           <div>
//             <Icon
//               as={MdDelete}
//               transitionDelay={'0.2s !important'}
//               fontSize={'18px'}
//               color={'grey'}
//               cursor={'pointer'}
//               onClick={() => delSeq(seq, index, name)}
//             />
//           </div>
//         </Tooltip>
//       </Box>

//       <Box
//         className="block-id"
//         mr={'10px'}
//         w={'50px'}
//         fontSize={'17px'}
//         color={'#1b2559'}
//         fontWeight={'700'}
//       >
//         {seq.id}
//       </Box>

//       <Box
//         className="box-block"
//         flex="1"
//         w="100%"
//         flexDirection={{ base: 'column', lg: 'row' }}
//         display="flex"
//         // alignItems="flex-start"
//         alignItems="stretch"
//       >
//         <Box
//           className="block-input-text"
//           mr="10px"
//           mb={{ base: '10px', lg: '0px' }}
//           w="100%"
//           display="grid"
//           rowGap="50px"
//         >
//              <Box
//   className="scenario-dropdown"
//   mb="10px"
// //   w={{ base: '100%', lg: '200px' }}
// >
//          <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
//     Select Scenario
//   </Text>

//  <Select
//   placeholder="Select Scenario"
//   options={scenarioOptions}
//   // value={input?.[`Note${seq.input}`]?.scenario || null}

//    value={
//  scenarioOptions.find(
//    (opt) =>
//      opt.value === input?.[`ScenarioCompletion${seq.input}`]?.scenario
//   ) || null
// }
// //  value={
// //                     scenarioOptions.find(
// //                       (opt:any) => opt.value === scData.scScenarioLevel
// //                     ) || null
// //                   }
//   onChange={(selected: any,option:any) =>{
//                     handleSCChange('scScenarioLevel', selected?.value)
//                      handleScenarioChange(selected);
//                       handleScenarioChanges(option, "scenario")
//                   }
//                   }
//                   // onChange={(selected: any) =>{
//                   //   handleSCChange('scScenarioLevel', selected?.value)
//                   //    handleScenarioChange(selected);
//                   // }
//                   // }
//    styles={{
//       ...customStyles,
//       control: (provided: any) => ({
//         ...provided,
//         borderRadius: '12px',
//         minHeight: '36px',
//       }),
//     }}
//     // onChange={handleScenarioChange}
//   isSearchable={false}
//   menuPortalTarget={document.body}
// />
// </Box>

//           {/* -------- LEADERBOARD + SCENARIO LEVEL -------- */}
//           <Flex
//             alignItems="center"
//             justifyContent="space-between"
//             w="100%"
//             maxW="600px"
//             gap="40px"
//           >
//             {/* Leaderboard Toggle */}
//             <FormControl
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//               w="300px"
//             >
//               <FormLabel fontSize="xl" fontWeight="bold" mb="0">
//                 Leaderboard
//               </FormLabel>
//               <Switch id="gameIsLeaderboardEnabled" name="gameIsLeaderboardEnabled"
//                 isChecked={scData.scLeaderboardEnabled === 'true'}
//                 onChange={(e) =>
//                   handleSCChange(
//                     'scLeaderboardEnabled',
//                     e.target.checked ? 'true' : 'false'
//                   )
//                 }
//               />
//             </FormControl>

//             {/* Scenario Level Dropdown */}
//             {/* <FormControl
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//               w="300px"
//             >
//               <FormLabel fontSize="xl" fontWeight="bold" mb="0">
//                 Scenario Level
//               </FormLabel>
//               <Box w="180px">
//                 <Select
//                   placeholder="Select level"
//                   id="scenarioLevel"
//                   name="scenarioLevel"
//                   options={scenarioOptions}
//                   isSearchable={false}
//                   isClearable={false}
//                   className="react-select"
//                   menuPortalTarget={document.body}
//                   styles={customStyles}
//                   value={
//                     scenarioOptions.find(
//                       (opt:any) => opt.value === scData.scScenarioLevel
//                     ) || null
//                   }
//                   onChange={(selected: any) =>
//                     handleSCChange('scScenarioLevel', selected?.value)
//                   }
//                 />
//               </Box>
//             </FormControl> */}

//             {/* Stars & Competency Toggles */}
//             {/* Stars Toggle */}
//             <FormControl
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//             >
//               <FormLabel fontSize="xl" fontWeight="bold" mb="0">
//                 Stars
//               </FormLabel>
//               <Switch id="gameIsStarsEnabled" name="gameIsStarsEnabled"
//                 isChecked={scData.scStarsEnabled === 'true'}
//                 onChange={(e) =>
//                   handleSCChange(
//                     'scStarsEnabled',
//                     e.target.checked ? 'true' : 'false'
//                   )
//                 }
//               />
//             </FormControl>

//             {/* Competency Meter Toggle */}
//             <FormControl
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//             >
//               <FormLabel fontSize="xl" fontWeight="bold" mb="0">
//                 Competency Meter
//               </FormLabel>
//               <Switch id="gameIsCompetencyEnabled" name="gameIsCompetencyEnabled"
//                 isChecked={scData.scCompetencyEnabled === 'true'}
//                 onChange={(e) =>
//                   handleSCChange(
//                     'scCompetencyEnabled',
//                     e.target.checked ? 'true' : 'false'
//                   )
//                 }
//               />
//             </FormControl>
//           </Flex>

//           <FormControl mt="20px">
//             <FormLabel
//               htmlFor="alerts"
//               mb="0"
//               fontSize="lg"
//               fontWeight="bold"
//               // color={textColorPrimary}
//               mr="2"
//             >
//               Show Interaction Feedback
//             </FormLabel>
//             {/* <RadioGroup
//               name="gameIsShowInteractionFeedBack"
//               id="alerts"
           
//             >
//               <Stack direction="row" spacing={5}>
//                 {options.map((option) => (
//                   <Radio
//                     key={option?.value}
//                     value={option?.value}
//                     color="#422afb"
//                   >
//                     <Text fontSize="0.875rem">
//                       {' '}
//                       {option?.name}
//                     </Text>
//                   </Radio>
//                 ))}
//               </Stack>
//             </RadioGroup> */}
//             {/* newwww */}
//             <div className="flex flex-row gap-6 mt-2">
//               {/* Immediately */}
//               <label className="flex items-center gap-3 cursor-pointer">
//                 <input
//                   type="radio"
//                   name={`ScenarioCompletion${seq.input}`}
//                   value="Each"
//                   checked={interactionValue === "Each"}
//                   onChange={(e) => {
//                     setInteractionValue(e.target.value); 
//                     handleScenarioChanges(e, "interaction"); 
//                   }}
//                   className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
//                 />
//                 <span className="text-sm text-gray-800">Each</span>
//               </label>

//               {/* Together */}
//               <label className="flex items-center gap-3 cursor-pointer">
//                 <input
//                   type="radio"
//                   name={`ScenarioCompletion${seq.input}`}
//                   value="Completion"
//                   checked={interactionValue === "Completion"}
//                   onChange={(e) => {
//                     setInteractionValue(e.target.value); 
//                     handleScenarioChanges(e, "interaction"); 
//                   }}
//                   className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
//                 />
//                 <span className="text-sm text-gray-800">Completion</span>
//               </label>
//             </div>
//           </FormControl>

//           {/* -------- SCORE UI -------- */}
//           <Box
//             mt="12px"
//             display="grid"
//             gridTemplateColumns="repeat(3, 1fr)"
//             columnGap="20px"
//             rowGap="16px"
//             alignItems="flex-start"
//           >
//             <Text fontSize="15px" fontWeight="700" gridColumn="1 / -1">
//               Score
//             </Text>

//             {/* Total Score */}
//             <FormControl>
//               <FormLabel fontSize="sm" fontWeight="bold">
//                 Total Score <span style={{ color: 'red' }}>*</span>
//               </FormLabel>
//               {/* <InputField id="gameTotalScore" name="gameTotalScore" w="100%" /> */}
//               <InputField
//                 id="totalScore"
//                 // value={scData.totalScore ?? ''}
//                 // onChange={(e: any) => handleSCChange('totalScore', e.target.value)}
//                   value={scData.totalScore ?? ''}
               
//                  onChange={(e: any) => handleSCChange('scTotalScore', e.target.value)}
//               />
//             </FormControl>

//             {/* Minimum Pass Block */}
//             <Box>
//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Set a Minimum Pass Score
//                 </FormLabel>
//                 <Switch
//                   size="sm"
//                   // isChecked={scData.showMinPass ?? false}
//                   // onChange={(e) =>
//                   //   handleSCChange('showMinPass', e.target.checked)
//                   // }
//                   isChecked={scData.scMinPassEnabled === 'true'}
//                   onChange={(e) =>
//                     handleSCChange(
//                       'scMinPassEnabled',
//                       e.target.checked ? 'true' : 'false'
//                     )
//                   }
//                 />
//               </FormControl>

//               {scData.scMinPassEnabled === 'true' && (
//                 <FormControl mt="10px">
//                   <FormLabel fontSize="sm" fontWeight="bold">
//                     Minimum Score
//                   </FormLabel>
//                   {/* <InputField placeholder="eg. 500" /> */}
//                   <InputField
//                     placeholder="eg. 500"
//                     value={scData.scMinPassScore ?? ''}
//                     onChange={(e: any) =>
//                       handleSCChange('scMinPassScore', e.target.value)
//                     }
//                   />
//                 </FormControl>
//               )}
//             </Box>

//             {/* Distinction Block */}
//             <Box>
//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Set a Distinction Score
//                 </FormLabel>
//                 <Switch
//                   size="sm"
//                   isChecked={scData.scDistinctionEnabled === 'true'}
//                   onChange={(e) => {
//                     handleSCChange(
//                       'scDistinctionEnabled',
//                       e.target.checked ? 'true' : 'false',
//                     );

//                     // clear score when turned OFF
//                     if (!e.target.checked) {
//                       handleSCChange('scDistinctionScore', null);
//                     }
//                   }}
//                 />
//               </FormControl>

//               {scData.scDistinctionEnabled === 'true' && (
//                 <FormControl mt="10px">
//                   <FormLabel fontSize="sm" fontWeight="bold">
//                     Distinction Score
//                   </FormLabel>
//                   <InputField
//                     placeholder="eg. 800"
//                     value={scData.scDistinctionScore ?? ''}
//                     onChange={(e: any) =>
//                       handleSCChange('scDistinctionScore', e.target.value)
//                     }
//                   />
//                 </FormControl>
//               )}
//             </Box>
//           </Box>

//           {/* -------- BADGE -------- */}
//           <Flex mt="20px" alignItems="flex-start" gap="30px" w="100%">
//             {/* Badge Toggle */}
//             <FormControl
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//               maxW="220px"
//             >
//               <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                 <Text fontSize={18} fontWeight={700}>Badge</Text>
//               </FormLabel>
//               <Switch
//                 size="md"
//                 id="gameIsSetBadge"
//                 name="gameIsSetBadge"
//                 isChecked={scData.scBadgeEnabled === 'true'}
//                 onChange={(e) =>
//                   handleSCChange(
//                     'scBadgeEnabled',
//                     e.target.checked ? 'true' : 'false'
//                   )
//                 }
//               />
//             </FormControl>

//             {/* Badge Content */}
//             {scData.scBadgeEnabled === 'true' && (
//               <Box flex="1">
//                 <FormControl mb="10px">
//                   <FormLabel fontWeight="bold">
//                     Select Badge <span style={{ color: 'red' }}>*</span>
//                   </FormLabel>
//                   <Button w="200px">Choose Badge</Button>
//                 </FormControl>

//                 <FormControl mb="10px">
//                   <FormLabel fontWeight="bold">
//                     Badge Name <span style={{ color: 'red' }}>*</span>
//                   </FormLabel>
//                   <InputField maxLength={10}
//                     value={scData.scBadgeName ?? ''}
//                     onChange={(e: any) =>
//                       handleSCChange('scBadgeName', e.target.value)
//                     }
//                   />
//                   <Text fontSize="12px">10 Characters left</Text>
//                 </FormControl>

//                 <FormControl
//                   display="flex"
//                   alignItems="center"
//                   justifyContent="space-between"
//                   maxW="300px"
//                 >
//                   <FormLabel fontWeight="bold" mb="0">
//                     Criteria For Badge
//                   </FormLabel>
//                  <Switch
//                   isChecked={scData.scBadgeCriteriaEnabled === 'true'}
//                     onChange={(e) =>
//                       handleSCChange(
//                         'scBadgeCriteriaEnabled',
//                         e.target.checked ? 'true' : 'false'
//                       )
//                     }
//                   />
//                 </FormControl>

//                 {scData.scBadgeCriteriaEnabled === 'true' && (
//                   <FormControl mt="10px" maxW="300px">
//                     <FormLabel fontWeight="bold">
//                       Score Greater Than <span style={{ color: 'red' }}>*</span>
//                     </FormLabel>
//                     <InputField placeholder="eg. 200"
//                       value={scData.scBadgeCriteriaScore ?? ''}
//                       onChange={(e: any) =>
//                         handleSCChange('scBadgeCriteriaScore', e.target.value)
//                       }
//                     />
//                   </FormControl>
//                 )}
//               </Box>
//             )}

//             <Box flex="1" maxW="400px">
//               <Text fontSize={18} fontWeight={700}>
//                 Screen Title
//               </Text>
//               <InputField
//                 mt="8px"
//                 placeholder="eg. Quest Complete"
//                 id="gameScreenTitle"
//                 name="gameScreenTitle"
//                 maxLength={16}
//                 w="100%"
//                  value={scData.scScreenTitle ?? ''}
//                 onChange={(e: any) => handleSCChange('scScreenTitle', e.target.value)}
//               />
//               <Text fontSize="12px" ml="2px">
//                 Characters left
//               </Text>
//             </Box>
//           </Flex>

//           {/* Congratulatory Message */}
//           {/* <FormControl>
//             <Text fontSize={18} fontWeight={700}>
//               Congratulatory Message
//             </Text>
//             <TextField
//               w="50%"
//               placeholder="eg. Congratulations! You have completed..."
//               mt="30px"
//               id="gameCompletedCongratsMessage"
//               name="gameCompletedCongratsMessage"
//               maxLength={80}
//               mb="0px"
//             />
//             <Text fontSize="12px" ml="2.5px">
//               Characters left
//             </Text>
//           </FormControl> */}
//           {/* 
//           {(scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true') && (
//             <Box mt="20px">
//               <Text fontSize={18} fontWeight={700}>
//                 Congratulatory Message
//               </Text>

//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//                 mt="20px"
//                 w="50%"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Single Message
//                 </FormLabel>
//                 <Switch
//                   isChecked={isSingleCongrats}
//                   onChange={() => {
//                     setIsSingleCongrats(true);
//                     setIsScoreWiseCongrats(false);
//                   }}
//                 />
//               </FormControl>

//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//                 mt="15px"
//                 w="50%"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Score-Wise Message
//                 </FormLabel>
//                 <Switch
//                   isChecked={isScoreWiseCongrats}
//                   onChange={() => {
//                     setIsSingleCongrats(false);
//                     setIsScoreWiseCongrats(true);
//                   }}
//                 />
//               </FormControl>
//             </Box>
//           )} */}
//           {hasScoreLogic && (
//             <Box mt="20px">
//               <Text fontSize={18} fontWeight={700}>
//                 Congratulatory Message
//               </Text>

//               {/* Single Message */}
//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//                 mt="20px"
//                 w="50%"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Single Message
//                 </FormLabel>
//                 {/* <Switch
//                   isChecked={congratsMode === 'Single'}
//                   onChange={(e) =>
//                     handleSCChange(
//                       'scCongratsMode',
//                       e.target.checked ? 'Single' : null
//                     )
//                   }
//                 /> */}
//                 <Switch
//                   isChecked={congratsMode === 'Single'}
//                   onChange={() =>
//                     handleSCChange(
//                       'scCongratsMode',
//                       congratsMode === 'Single' ? null : 'Single'
//                     )
//                   }
//                 />

//               </FormControl>

//               {/* Score Wise Message */}
//               <FormControl
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//                 mt="15px"
//                 w="50%"
//               >
//                 <FormLabel fontSize="sm" fontWeight="bold" mb="0">
//                   Score-Wise Message
//                 </FormLabel>
//                 {/* <Switch
//                   isChecked={congratsMode === 'ScoreWise'}
//                   onChange={(e) =>
//                     handleSCChange(
//                       'scCongratsMode',
//                       e.target.checked ? 'ScoreWise' : null
//                     )
//                   }
//                 /> */}
//                 <Switch
//                   isChecked={congratsMode === 'ScoreWise'}
//                   onChange={() =>
//                     handleSCChange(
//                       'scCongratsMode',
//                       congratsMode === 'ScoreWise' ? null : 'ScoreWise'
//                     )
//                   }
//                 />

//               </FormControl>
//             </Box>
//           )}


//           {/* {(!(scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true') || isSingleCongrats) && ( */}
//           {(!hasScoreLogic || congratsMode === 'Single') && (
//             <FormControl mt="30px">
//               <Text fontSize={18} fontWeight={700}>
//                 Congratulatory Message
//               </Text>
//               <TextField
//                 w="50%"
//                 placeholder="eg. Congratulations! You have completed..."
//                 mt="20px"
//                 id="gameCompletedCongratsMessage"
//                 name="gameCompletedCongratsMessage"
//                 maxLength={80}
//                 // value={scData.singleCongrats ?? ''}
//                 // onChange={(e: any) => handleSCChange('singleCongrats', e.target.value)}
//                 value={scData.scCongratsMessageSingle ?? ''}
//                 onChange={(e: any) =>
//                   handleSCChange('scCongratsMessageSingle', e.target.value)
//                 }
//               />
//               <Text fontSize="12px" ml="2.5px">
//                 Characters left
//               </Text>
//             </FormControl>
//           )}

//           {/* {scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true' && isScoreWiseCongrats && ( */}
//           {hasScoreLogic && congratsMode === 'ScoreWise' && (
//             <Box mt="30px">

//               {scData.scMinPassEnabled === 'true' && (
//                 <FormControl mb="20px">
//                   <FormLabel fontSize="sm" fontWeight="bold">
//                     For less than minimum score
//                   </FormLabel>
//                   <TextField
//                     placeholder="eg. You can do better..."
//                     maxLength={80}
//                     value={scData.scCongratsBelowMin ?? ''}
//                     onChange={(e: any) =>
//                       handleSCChange('scCongratsBelowMin', e.target.value)
//                     }
//                   />
//                 </FormControl>
//               )}

//               {(scData.scMinPassEnabled === 'true' ||
//                 scData.scDistinctionEnabled === 'true') && (
//                   <FormControl mb="20px">
//                     <FormLabel fontSize="sm" fontWeight="bold">
//                       For more than minimum score
//                     </FormLabel>
//                     <TextField
//                       placeholder="eg. Great job!"
//                       maxLength={80}
//                       value={scData.scCongratsAboveMin ?? ''}
//                       onChange={(e: any) =>
//                         handleSCChange('scCongratsAboveMin', e.target.value)
//                       }
//                     />
//                   </FormControl>
//                 )}

//               {scData.scDistinctionEnabled === 'true' && (
//                 <FormControl>
//                   <FormLabel fontSize="sm" fontWeight="bold">
//                     For above distinction score
//                   </FormLabel>
//                   <TextField
//                     placeholder="eg. Outstanding performance!"
//                     maxLength={80}
//                     value={scData.scCongratsAboveDistinction ?? ''}
//                     onChange={(e: any) =>
//                       handleSCChange('scCongratsAboveDistinction', e.target.value)
//                     }
//                   />
//                 </FormControl>
//               )}

//             </Box>
//           )}

//         </Box>

//         <Box
//           className="navigation-icon"
//           // h={'100%'}
//           display={'flex'}
//           alignItems={'center'}
//           justifyContent={'center'}
//           mr={'40px'}
//           width={'auto'}
//         >
//           <Flex>
//             <Box>
//               <Tooltip hasArrow label="Add Navigations">
//                 <div>
//                   <Menu
//                     tabState={'leadDialog'}
//                     id={seq.input}
//                     for={`ScenarioCompletion${seq.input}`}
//                     setNavigation={setNavigation}
//                     handleBlock={handleBlock}
//                     items={items}
//                     seq={seq}
//                   />
//                 </div>
//               </Tooltip>
//             </Box>

//             <Box
//               ml={'4px'}
//               cursor={'pointer'}
//               display={
//                 input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow
//                   ? 'block'
//                   : 'none'
//               }
//               zIndex={9999}
//             >
//               {input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow ===
//                 'New Block' &&
//                 !input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionnavigate ? (
//                 // Render content for New Block
//                 <>
//                   <MiniBox1 seq={seq} i={index} />
//                 </>
//               ) : input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow ===
//                 'Select Block' &&
//                 !input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionnavigate ? (
//                 // Render select tag for Select Block
//                 <Select
//                   placeholder={'Blocks...'}
//                   id="Dialog"
//                   name={`ScenarioCompletion${seq.input}`}
//                   menuPortalTarget={document.body}
//                   styles={customStyles}
//                   options={showSelectBlock.filter(
//                     (option: any) => option.value !== seq.input,
//                   )}
//                   isSearchable={true}
//                   className="react-select"
//                   value={
//                     showSelectBlock.find(
//                       (option: any) =>
//                         option.value ==
//                         input?.[`ScenarioCompletion${seq.input}`]
//                           ?.ScenarioCompletionnavigate,
//                     ) || null
//                   }
//                   onChange={(e: any) =>
//                     handleSelectBlock(
//                       e,
//                       seq.input,
//                       `ScenarioCompletion${seq.input}`,
//                       `ScenarioCompletion${seq.input}`,
//                     )
//                   }
//                 />
//               ) : (
//                 // Render content for the 'else' condition
//                 <>
//                   <div style={{ display: 'flex', alignItems: 'center' }}>
//                     <StrightConector
//                       name={
//                         input?.[`ScenarioCompletion${seq.input}`]
//                           ?.ScenarioCompletionleadShow === 'New Block'
//                           ? showSelectBlock.find(
//                             (option: any) =>
//                               option.value ==
//                               input?.[`ScenarioCompletion${seq.input}`]
//                                 ?.ScenarioCompletionnavigate,
//                           )?.label
//                           : input?.[`ScenarioCompletion${seq.input}`]
//                             ?.ScenarioCompletionleadShow === 'Select Block'
//                             ? showSelectBlock.find(
//                               (option: any) =>
//                                 option.value ==
//                                 input?.[`ScenarioCompletion${seq.input}`]
//                                   ?.ScenarioCompletionnavigate,
//                             )?.label
//                             : input?.[`ScenarioCompletion${seq.input}`]
//                               ?.ScenarioCompletionnavigate
//                       }
//                     />
//                   </div>
//                 </>
//               )}
//             </Box>
//           </Flex>
//         </Box>
//       </Box>
//     </Flex>
//   );
// };

// export default ScenarioCompletionCompo;







import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { FaChartLine } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import { FaLightbulb } from "react-icons/fa";
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { HiLink } from 'react-icons/hi';
import { ScenarioSelection,interactionfedback } from 'utils/game/gameService';
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  Textarea,
  Input,
  Divider,
  Tooltip,
  FormLabel,
  Switch,
  FormControl,
  RadioGroup,
  Stack,
  Radio,
} from '@chakra-ui/react';
import Select from 'react-select';
import {
  MdAdd,
  MdCloudUpload,
  MdInbox,
  MdNote,
  MdNoteAdd,
  MdTextsms,
  MdDelete,
  MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';
import Menu from '../components/Navigate';
import StrightConector from '../components/dragNdrop/strightConector';
import { TbHandClick, TbMessages } from 'react-icons/tb';
import InputField from 'components/fields/InputField';
import { SearchIcon } from '@chakra-ui/icons';
import TextField from 'components/fields/TextField';
import BadgeImages from '../components/BadgeImages';
import { FaAward } from 'react-icons/fa6';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
import { getImages } from 'utils/game/gameService';
interface PropsNote {
  reviews?: any;
  listBlockItems?: any;
  id?: number;
  formData?: any;
  language?: any;
  seq?: any;
  index?: number;
  handleNDI?: any;
  name?: any;
  handleInput?: any;
  GameId?:any;
  input?: any;
  getSeq?: any;
  handleMiniNDI?: any;
  duplicateSeq?: any;
  delSeq?: any;
  alphabet?: any;
  setNavigation: any;
  handleBlock: any;
  items?: any;
  formDataGamelanguageCode?: any;
  handleSelectBlock?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  currentseq?: any;
  ShowReview?: any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
  BlockItems:any;
}

interface Block {
  blockPrimarySequence: string;
  content: string | undefined;
}

const ScenarioCompletionCompo: React.FC<PropsNote> = ({
  targetSequence,
  listBlockItems,
  GameId,
formData,
  seq,
  index,
  name,
  handleInput,
  input,
  getSeq,
  duplicateSeq,
  delSeq,
  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,
  showSelectBlock,
  handleNDI,
  validation,
  BlockItems,
}) => {
  // new
  const [interactionValue, setInteractionValue] = useState<string | null>(null);
  const hasInitialized = useRef(false);
   const [senarioBadgeData, setSenarioBadgeData] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [senarioImg, setSenarioImg] = useState(null);
  console.log('seqseq', seq);
  console.log('InPut from ScenarioCompletionCompo:', input);
 const gameQuestNo =BlockItems[0].questNo;
  const blockKey = `ScenarioCompletion${seq.input}`;
  // const scData = input?.[blockKey] || {};
    const scData = {
  ...input?.[blockKey],
  totalScore:
    input?.[blockKey]?.totalScore ??
    input?.[blockKey]?.scTotalScore ??
    '',
};
console.log(listBlockItems,'listBlockItems')
  // const [totalScore, setTotalScore] = useState<number | null>(null);
  // const [minPassScore, setMinPassScore] = useState<number | null>(null);
  const blockItemsArray = useMemo(() => {
    if (Array.isArray(listBlockItems)) return listBlockItems;

    if (listBlockItems && typeof listBlockItems === "object") {
      return Object.values(listBlockItems);
    }

    return [];
  }, [listBlockItems]);
   const userDetails = JSON.parse(localStorage.getItem('user'));
  console.log('userDetailssdfwr',userDetails);
    const ctId = userDetails?.data?.id.toString();
    const handleBadgeImages = async () => {
  console.log('Choose Badge button clicked');

  const result = await getImages(4, ctId);

  if (result?.status !== 'Success') {
    console.log('getbackground error:', result?.message);
    return;
  }

  console.log('Badge images data:', result.data);

  setSenarioBadgeData(result.data);   // 🔥 image data
  setIsModalOpen(true);               // 🔥 popup OPEN (missing earlier)
};
const handleScenarioBadgeSelection = (badge: any) => {
  console.log('Selected badge:', badge);

  handleSCChange('scBadgeId', badge.gasId);
  handleSCChange('scBadgeName', badge.gasAssetName);
  handleSCChange(
    'scBadgeImage',
    badge.gasAssetImage        // ## FIX: correct image key
  );

  setIsModalOpen(false);
};

  /* new logic*/
  const selectedItem = useMemo(() => {
    return blockItemsArray.find(
      (item: any) =>
        item.id === seq.id &&
        item.questNo === seq.questNo &&
        item.input === seq.input &&
        item.type === seq.type
    );
  }, [blockItemsArray, seq]);

  // new
  useEffect(() => {
    if (interactionValue === null) {
      const backendValue =
        selectedItem?.interactionfeedback ||
        input?.[`ScenarioCompletion${seq.input}`]?.interactionfeedback;

      if (backendValue) {
        setInteractionValue(backendValue);
        hasInitialized.current = true;
      }
    }
  }, [selectedItem, input, seq.input]);
  // const [distinctionScore, setDistinctionScore] = useState<number | null>(null);
  // const [screenTitle, setScreenTitle] = useState<string | null>(null);
  // const [singleCongrats, setSingleCongrats] = useState<string | null>(null);
  // const [belowMinMsg, setBelowMinMsg] = useState<string | null>(null);
  // const [aboveMinMsg, setAboveMinMsg] = useState<string | null>(null);
  // const [aboveDistinctionMsg, setAboveDistinctionMsg] = useState<string | null>(null);
  // const [showMinPass, setShowMinPass] = useState(false);
  // const [showDistinction, setShowDistinction] = useState(false);
  // const [showBadge, setShowBadge] = useState(false);
  // const [showCongrats, setShowCongrats] = useState(false);
  // const [bagdgeCriteria, setBadgeCriteria] = useState(false);
  // const [isSingleCongrats, setIsSingleCongrats] = useState(true);
  // const [isScoreWiseCongrats, setIsScoreWiseCongrats] = useState(false);

  // const textareaRef = useRef(null);


  const hasScoreLogic =
    scData.scMinPassEnabled === 'true' ||
    scData.scDistinctionEnabled === 'true';

  const congratsMode = scData.scCongratsMode ?? 'Single';


  // shiw interaction feedback options
  const options = [
    { value: 'Each', name: 'Immediately After Each Interaction' },
    { value: 'Completion', name: ' Together After Completion Screen' },
  ];

  // basic / complex options
//   const scenarioLevelOptions = [
//     { value: 'basic', label: 'Basic' },
//     { value: 'complex', label: 'Complex' },
//   ];

  const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
  label: `Scenario ${i + 1}`,
  value: `Scenario ${i + 1}`,
}));

 

 
  const customStyles = {
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '130px',
      padding: '0 !important',
    }),
  };
  const gameId = GameId
//  const gameQuestNo = formData.gameQuestNo;
  console.log('formDataformDataformDatainapi', gameQuestNo);
  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value !== '') {
      handleSelectBlock(
        { value: input },
        input,
        `ScenarioCompletion${seq.input}`,
        `ScenarioCompletion${seq.input}`,
      );
    }
  };

  const MiniBox1 = (props: { seq?: any; i?: number; name?: any; bodyRef?: any }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'relative'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Note', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                   Note
                 </ListItem>
       
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                   Dialog
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                 >
                   <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                   Interaction
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Link', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                   Link
                 </ListItem>
                 
                   <>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                       Reflection
                     </ListItem>
       
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                       Overview
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                       KeyInsights
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                       PreAssessment
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                       PostAssessment
                     </ListItem>
                       <ListItem
                                                             onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                                                             p={'10px'}
                                                             display={'flex'}
                                                             alignItems={'center'}
                                                             borderBottom={'2px solid #f1f1f170'}
                                                           >
                                                             <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                                                             WehaveChoose
                                                           </ListItem>
                                                                      <ListItem
                                                             onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                                                             p={'10px'}
                                                             display={'flex'}
                                                             alignItems={'center'}
                                                             borderBottom={'2px solid #f1f1f170'}
                                                           >
                                                             <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                                                             Swipe
                                                           </ListItem>
                                                                      <ListItem
                                                             onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                                                             p={'10px'}
                                                             display={'flex'}
                                                             alignItems={'center'}
                                                             borderBottom={'2px solid #f1f1f170'}
                                                           >
                                                             <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                                                             Drag For Now 
                                                           </ListItem>
                     
                   </>
                
                 {formData?.gameScenarioCompletion === 'true' && (
                   <ListItem
                     onClick={() =>
                       handleMiniNDInewblock('ScenarioCompletion', seq, i)
                     }
                     p={'10px'}
                     display={'flex'}
                     alignItems={'center'}
                     borderBottom={'2px solid #f1f1f170'}
                   >
                     <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                     ScenarioCompletion
                   </ListItem>
                 )}
               </List>
      </Box>
    );
  };

  let focusSeqRef: any;
  const justClick = (event: any, seq: any) => {
    if (event.type === 'click') {
      focusSeqRef = document.getElementsByClassName(seq.id);
      const element = focusSeqRef?.[0];
      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };
// const handleScenarioChange = async (option: any) => {
//   const selectedScenario = option?.value; // e.g. "Scenario 1"

//   // update local state
//   handleInput({
//     name: `ScenarioCompletion${seq.input}`,
//     value: {
//       scenario: selectedScenario,
//     },
//   });

//   // call backend
//   try {
//     const response = await ScenarioSelection(gameId, selectedScenario);
//     console.log("Scenario API response:", response);
//   } catch (error) {
//     console.error("Failed to send scenario", error);
//   }
// };
  const handleScenarioChanges = async (
    data: any,
    source: "scenario" | "interaction"
  ) => {
    const prev = input?.[`ScenarioCompletion${seq.input}`] || {};

    const updatedValue = {
      scenario:
        source === "scenario" ? data?.value : prev.scenario,
      interactionfeedback:
        source === "interaction" ? data.target.value : prev.interactionfeedback,
    };

    // update local state
    handleInput({
      name: `ScenarioCompletion${seq.input}`,
      value: updatedValue,
    });

    // call API ONLY when both values exist
    if (updatedValue.scenario && updatedValue.interactionfeedback) {
      try {
        const response = await interactionfedback(
          gameId,
          gameQuestNo,
          updatedValue.scenario,
          updatedValue.interactionfeedback
        );
        console.log("Scenario API response:", response);
      } catch (error) {
        console.error("Failed to send scenario", error);
      }
    }
  };

const handleScenarioChange = async (option: any) => {
  const selectedScenario = option?.value;

  // update selected scenario
  handleInput({
    name: `ScenarioCompletion${seq.input}`,
    value: {
      scenario: selectedScenario,
    },
  });

  try {
    const response = await ScenarioSelection(gameId, selectedScenario);
    console.log("Scenario API response:", response);

    if (response?.success) {
      // ✅ set total score from backend
      handleSCChange("totalScore", response.totalScore);
    }
  } catch (error) {
    console.error("Failed to send scenario", error);
  }
};


  const handleSCChange = (field: string, value: any) => {
    handleInput(
      {
        target: {
          name: `ScenarioCompletion${seq.input}`,
          id: field,
          value,
        },
      },
      index,
      seq.input,
    );
  };

  return (
    <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
      <Box className="block-action-icons">
        <Tooltip hasArrow label="Choose New Block">
          <div>
            <Icon
              as={MdAdd}
              transitionDelay={'0s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() => getSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Duplicate">
          <div>
            <Icon
              as={BiSolidDuplicate}
              transitionDelay={'0.1s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() =>
                duplicateSeq(seq, index, name, input?.[`ScenarioCompletion${seq.input}`])
              }
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Delete ScenarioCompletion">
          <div>
            <Icon
              as={MdDelete}
              transitionDelay={'0.2s !important'}
              fontSize={'18px'}
              color={'grey'}
              cursor={'pointer'}
              onClick={() => delSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
      </Box>

      <Box
        className="block-id"
        mr={'10px'}
        w={'50px'}
        fontSize={'17px'}
        color={'#1b2559'}
        fontWeight={'700'}
      >
        {seq.id}
      </Box>

      <Box
        className="box-block"
        flex="1"
        w="100%"
        flexDirection={{ base: 'column', lg: 'row' }}
        display="flex"
        // alignItems="flex-start"
        alignItems="stretch"
      >
        <Box
          className="block-input-text"
          mr="10px"
          mb={{ base: '10px', lg: '0px' }}
          w="100%"
          display="grid"
          rowGap="50px"
        >
             <Box
  className="scenario-dropdown"
  mb="10px"
//   w={{ base: '100%', lg: '200px' }}
>
         <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
    Select Scenario
  </Text>

 <Select
  placeholder="Select Scenario"
  options={scenarioOptions}
  // value={input?.[`Note${seq.input}`]?.scenario || null}

   value={
 scenarioOptions.find(
   (opt) =>
     opt.value === input?.[`ScenarioCompletion${seq.input}`]?.scenario
  ) || null
}
//  value={
//                     scenarioOptions.find(
//                       (opt:any) => opt.value === scData.scScenarioLevel
//                     ) || null
//                   }
  onChange={(selected: any,option:any) =>{
                    handleSCChange('scScenarioLevel', selected?.value)
                     handleScenarioChange(selected);
                      handleScenarioChanges(option, "scenario")
                  }
                  }
                  // onChange={(selected: any) =>{
                  //   handleSCChange('scScenarioLevel', selected?.value)
                  //    handleScenarioChange(selected);
                  // }
                  // }
   styles={{
      ...customStyles,
      control: (provided: any) => ({
        ...provided,
        borderRadius: '12px',
        minHeight: '36px',
      }),
    }}
    // onChange={handleScenarioChange}
  isSearchable={false}
  menuPortalTarget={document.body}
/>
</Box>

          {/* -------- LEADERBOARD + SCENARIO LEVEL -------- */}
          <Flex
            alignItems="center"
            justifyContent="space-between"
            w="100%"
            maxW="600px"
            gap="40px"
          >
            {/* Leaderboard Toggle */}
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              w="300px"
            >
              <FormLabel fontSize="xl" fontWeight="bold" mb="0">
                Leaderboard
              </FormLabel>
              <Switch id="gameIsLeaderboardEnabled" name="gameIsLeaderboardEnabled"
                isChecked={scData.scLeaderboardEnabled === 'true'}
                onChange={(e) =>
                  handleSCChange(
                    'scLeaderboardEnabled',
                    e.target.checked ? 'true' : 'false'
                  )
                }
              />
            </FormControl>

            {/* Scenario Level Dropdown */}
            {/* <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              w="300px"
            >
              <FormLabel fontSize="xl" fontWeight="bold" mb="0">
                Scenario Level
              </FormLabel>
              <Box w="180px">
                <Select
                  placeholder="Select level"
                  id="scenarioLevel"
                  name="scenarioLevel"
                  options={scenarioOptions}
                  isSearchable={false}
                  isClearable={false}
                  className="react-select"
                  menuPortalTarget={document.body}
                  styles={customStyles}
                  value={
                    scenarioOptions.find(
                      (opt:any) => opt.value === scData.scScenarioLevel
                    ) || null
                  }
                  onChange={(selected: any) =>
                    handleSCChange('scScenarioLevel', selected?.value)
                  }
                />
              </Box>
            </FormControl> */}

            {/* Stars & Competency Toggles */}
            {/* Stars Toggle */}
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <FormLabel fontSize="xl" fontWeight="bold" mb="0">
                Stars
              </FormLabel>
              <Switch id="gameIsStarsEnabled" name="gameIsStarsEnabled"
                isChecked={scData.scStarsEnabled === 'true'}
                onChange={(e) =>
                  handleSCChange(
                    'scStarsEnabled',
                    e.target.checked ? 'true' : 'false'
                  )
                }
              />
            </FormControl>

            {/* Competency Meter Toggle */}
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <FormLabel fontSize="xl" fontWeight="bold" mb="0">
                Competency Meter
              </FormLabel>
              <Switch id="gameIsCompetencyEnabled" name="gameIsCompetencyEnabled"
                isChecked={scData.scCompetencyEnabled === 'true'}
                onChange={(e) =>
                  handleSCChange(
                    'scCompetencyEnabled',
                    e.target.checked ? 'true' : 'false'
                  )
                }
              />
            </FormControl>
          </Flex>

          <FormControl mt="20px">
            <FormLabel
              htmlFor="alerts"
              mb="0"
              fontSize="lg"
              fontWeight="bold"
              // color={textColorPrimary}
              mr="2"
            >
              Show Interaction Feedback
            </FormLabel>
            {/* <RadioGroup
              name="gameIsShowInteractionFeedBack"
              id="alerts"
           
            >
              <Stack direction="row" spacing={5}>
                {options.map((option) => (
                  <Radio
                    key={option?.value}
                    value={option?.value}
                    color="#422afb"
                  >
                    <Text fontSize="0.875rem">
                      {' '}
                      {option?.name}
                    </Text>
                  </Radio>
                ))}
              </Stack>
            </RadioGroup> */}
            {/* newwww */}
            <div className="flex flex-row gap-6 mt-2">
              {/* Immediately */}
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name={`ScenarioCompletion${seq.input}`}
                  value="Each"
                  checked={interactionValue === "Each"}
                  onChange={(e) => {
                    setInteractionValue(e.target.value); 
                    handleScenarioChanges(e, "interaction"); 
                  }}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                />
                <span className="text-sm text-gray-800">Each</span>
              </label>

              {/* Together */}
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name={`ScenarioCompletion${seq.input}`}
                  value="Completion"
                  checked={interactionValue === "Completion"}
                  onChange={(e) => {
                    setInteractionValue(e.target.value); 
                    handleScenarioChanges(e, "interaction"); 
                  }}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                />
                <span className="text-sm text-gray-800">Completion</span>
              </label>
            </div>
          </FormControl>

          {/* -------- SCORE UI -------- */}
          <Box
            mt="12px"
            display="grid"
            gridTemplateColumns="repeat(3, 1fr)"
            columnGap="20px"
            rowGap="16px"
            alignItems="flex-start"
          >
            <Text fontSize="15px" fontWeight="700" gridColumn="1 / -1">
              Score
            </Text>

            {/* Total Score */}
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="bold">
                Total Score <span style={{ color: 'red' }}>*</span>
              </FormLabel>
              {/* <InputField id="gameTotalScore" name="gameTotalScore" w="100%" /> */}
              <InputField
                id="totalScore"
                // value={scData.totalScore ?? ''}
                // onChange={(e: any) => handleSCChange('totalScore', e.target.value)}
                  value={scData.totalScore ?? ''}
               
                 onChange={(e: any) => handleSCChange('scTotalScore', e.target.value)}
              />
            </FormControl>

            {/* Minimum Pass Block */}
            <Box>
              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Set a Minimum Pass Score
                </FormLabel>
                <Switch
                  size="sm"
                  // isChecked={scData.showMinPass ?? false}
                  // onChange={(e) =>
                  //   handleSCChange('showMinPass', e.target.checked)
                  // }
                  isChecked={scData.scMinPassEnabled === 'true'}
                  onChange={(e) =>
                    handleSCChange(
                      'scMinPassEnabled',
                      e.target.checked ? 'true' : 'false'
                    )
                  }
                />
              </FormControl>

              {scData.scMinPassEnabled === 'true' && (
                <FormControl mt="10px">
                  <FormLabel fontSize="sm" fontWeight="bold">
                    Minimum Score
                  </FormLabel>
                  {/* <InputField placeholder="eg. 500" /> */}
                  <InputField
                    placeholder="eg. 500"
                    value={scData.scMinPassScore ?? ''}
                    onChange={(e: any) =>
                      handleSCChange('scMinPassScore', e.target.value)
                    }
                  />
                </FormControl>
              )}
            </Box>

            {/* Distinction Block */}
            <Box>
              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Set a Distinction Score
                </FormLabel>
                <Switch
                  size="sm"
                  isChecked={scData.scDistinctionEnabled === 'true'}
                  onChange={(e) => {
                    handleSCChange(
                      'scDistinctionEnabled',
                      e.target.checked ? 'true' : 'false',
                    );

                    // clear score when turned OFF
                    if (!e.target.checked) {
                      handleSCChange('scDistinctionScore', null);
                    }
                  }}
                />
              </FormControl>

              {scData.scDistinctionEnabled === 'true' && (
                <FormControl mt="10px">
                  <FormLabel fontSize="sm" fontWeight="bold">
                    Distinction Score
                  </FormLabel>
                  <InputField
                    placeholder="eg. 800"
                    value={scData.scDistinctionScore ?? ''}
                    onChange={(e: any) =>
                      handleSCChange('scDistinctionScore', e.target.value)
                    }
                  />
                </FormControl>
              )}
            </Box>
          </Box>

          {/* -------- BADGE -------- */}
          <Flex mt="20px" alignItems="flex-start" gap="30px" w="100%">
            {/* Badge Toggle */}
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              maxW="220px"
            >
              <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                <Text fontSize={18} fontWeight={700}>Badge</Text>
              </FormLabel>
              <Switch
                size="md"
                id="gameIsSetBadge"
                name="gameIsSetBadge"
                isChecked={scData.scBadgeEnabled === 'true'}
                onChange={(e) =>
                  handleSCChange(
                    'scBadgeEnabled',
                    e.target.checked ? 'true' : 'false'
                  )
                }
              />
            </FormControl>

            {/* {scData.scBadgeEnabled === 'true' && (
              <Box flex="1">
                <FormControl mb="10px">
                  <FormLabel fontWeight="bold">
                    Select Badge <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                  <Button w="200px"
                  onClick={() => handleBadgeImages()}
                  >Choose Badge</Button>
          
                </FormControl>

                <FormControl mb="10px">
                  <FormLabel fontWeight="bold">
                    Badge Name <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                  <InputField maxLength={10}
                    value={scData.scBadgeName ?? ''}
                    onChange={(e: any) =>
                      handleSCChange('scBadgeName', e.target.value)
                    }
                  /> */}

                  {scData.scBadgeEnabled === 'true' && (
  <Box flex="1">

    {/* -------- Select Badge -------- */}
    <FormControl
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb="10px"
      maxW="350px"
    >
      <FormLabel fontWeight="bold">
        Select Badge <span style={{ color: 'red' }}>*</span>
      </FormLabel>

      {/* 🔥 Badge popup component (MISSING BEFORE) */}
      <BadgeImages
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        badgeData={senarioBadgeData}
        handleBadgeSelection={handleScenarioBadgeSelection}
      />
    </FormControl>

    {/* -------- Choose / Preview -------- */}
    {!scData.scBadgeId ? (
      <Box
        display="inline-block"
        cursor="pointer"
        onClick={handleBadgeImages}
      >
        <Box
          backgroundColor="#422AFB"
          p="4px 10px"
          borderRadius="15px"
          display="flex"
          alignItems="center"
          gap="6px"
        >
          <SearchIcon color="#fff" w="15px" h="15px" />
          <Text fontSize="sm" color="#fff">
            Choose Badge
          </Text>
        </Box>
      </Box>
    ) : (
      <Box position="relative">
        <Img
          src={scData.scBadgeImage}
          w="50px"
          h="50px"
          borderRadius="6px"
        />
        <Icon
          as={MdClose}
          bg="#fff"
          position="absolute"
          top="0"
          right="0"
          borderRadius="50%"
          cursor="pointer"
          onClick={() => {
            handleSCChange('scBadgeId', '');
            handleSCChange('scBadgeImage', '');
            handleSCChange('scBadgeName', '');
          }}
        />
      </Box>
    )}

    {/* -------- Badge Name -------- */}
    <FormControl mt="10px">
      <FormLabel fontWeight="bold">
        Badge Name <span style={{ color: 'red' }}>*</span>
      </FormLabel>
      <InputField
        maxLength={10}
        value={scData.scBadgeName ?? ''}
        onChange={(e: any) =>
          handleSCChange('scBadgeName', e.target.value)
        }
      />
                  <Text fontSize="12px">10 Characters left</Text>
                </FormControl>

                <FormControl
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  maxW="300px"
                >
                  <FormLabel fontWeight="bold" mb="0">
                    Criteria For Badge
                  </FormLabel>
                 <Switch
                  isChecked={scData.scBadgeCriteriaEnabled === 'true'}
                    onChange={(e) =>
                      handleSCChange(
                        'scBadgeCriteriaEnabled',
                        e.target.checked ? 'true' : 'false'
                      )
                    }
                  />
                </FormControl>

                {scData.scBadgeCriteriaEnabled === 'true' && (
                  <FormControl mt="10px" maxW="300px">
                    <FormLabel fontWeight="bold">
                      Score Greater Than <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <InputField placeholder="eg. 200"
                      value={scData.scBadgeCriteriaScore ?? ''}
                      onChange={(e: any) =>
                        handleSCChange('scBadgeCriteriaScore', e.target.value)
                      }
                    />
                  </FormControl>
                )}
              </Box>
            )}

            <Box flex="1" maxW="400px">
              <Text fontSize={18} fontWeight={700}>
                Screen Title
              </Text>
              <InputField
                mt="8px"
                placeholder="eg. Quest Complete"
                id="gameScreenTitle"
                name="gameScreenTitle"
                maxLength={16}
                w="100%"
                 value={scData.scScreenTitle ?? ''}
                onChange={(e: any) => handleSCChange('scScreenTitle', e.target.value)}
              />
              <Text fontSize="12px" ml="2px">
                Characters left
              </Text>
            </Box>
          </Flex>

          {/* Congratulatory Message */}
          {/* <FormControl>
            <Text fontSize={18} fontWeight={700}>
              Congratulatory Message
            </Text>
            <TextField
              w="50%"
              placeholder="eg. Congratulations! You have completed..."
              mt="30px"
              id="gameCompletedCongratsMessage"
              name="gameCompletedCongratsMessage"
              maxLength={80}
              mb="0px"
            />
            <Text fontSize="12px" ml="2.5px">
              Characters left
            </Text>
          </FormControl> */}
          {/* 
          {(scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true') && (
            <Box mt="20px">
              <Text fontSize={18} fontWeight={700}>
                Congratulatory Message
              </Text>

              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mt="20px"
                w="50%"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Single Message
                </FormLabel>
                <Switch
                  isChecked={isSingleCongrats}
                  onChange={() => {
                    setIsSingleCongrats(true);
                    setIsScoreWiseCongrats(false);
                  }}
                />
              </FormControl>

              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mt="15px"
                w="50%"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Score-Wise Message
                </FormLabel>
                <Switch
                  isChecked={isScoreWiseCongrats}
                  onChange={() => {
                    setIsSingleCongrats(false);
                    setIsScoreWiseCongrats(true);
                  }}
                />
              </FormControl>
            </Box>
          )} */}
          {hasScoreLogic && (
            <Box mt="20px">
              <Text fontSize={18} fontWeight={700}>
                Congratulatory Message
              </Text>

              {/* Single Message */}
              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mt="20px"
                w="50%"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Single Message
                </FormLabel>
                {/* <Switch
                  isChecked={congratsMode === 'Single'}
                  onChange={(e) =>
                    handleSCChange(
                      'scCongratsMode',
                      e.target.checked ? 'Single' : null
                    )
                  }
                /> */}
                <Switch
                  isChecked={congratsMode === 'Single'}
                  onChange={() =>
                    handleSCChange(
                      'scCongratsMode',
                      congratsMode === 'Single' ? null : 'Single'
                    )
                  }
                />

              </FormControl>

              {/* Score Wise Message */}
              <FormControl
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mt="15px"
                w="50%"
              >
                <FormLabel fontSize="sm" fontWeight="bold" mb="0">
                  Score-Wise Message
                </FormLabel>
                {/* <Switch
                  isChecked={congratsMode === 'ScoreWise'}
                  onChange={(e) =>
                    handleSCChange(
                      'scCongratsMode',
                      e.target.checked ? 'ScoreWise' : null
                    )
                  }
                /> */}
                <Switch
                  isChecked={congratsMode === 'ScoreWise'}
                  onChange={() =>
                    handleSCChange(
                      'scCongratsMode',
                      congratsMode === 'ScoreWise' ? null : 'ScoreWise'
                    )
                  }
                />

              </FormControl>
            </Box>
          )}


          {/* {(!(scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true') || isSingleCongrats) && ( */}
          {(!hasScoreLogic || congratsMode === 'Single') && (
            <FormControl mt="30px">
              <Text fontSize={18} fontWeight={700}>
                Congratulatory Message
              </Text>
              <TextField
                w="50%"
                placeholder="eg. Congratulations! You have completed..."
                mt="20px"
                id="gameCompletedCongratsMessage"
                name="gameCompletedCongratsMessage"
                maxLength={80}
                // value={scData.singleCongrats ?? ''}
                // onChange={(e: any) => handleSCChange('singleCongrats', e.target.value)}
                value={scData.scCongratsMessageSingle ?? ''}
                onChange={(e: any) =>
                  handleSCChange('scCongratsMessageSingle', e.target.value)
                }
              />
              <Text fontSize="12px" ml="2.5px">
                Characters left
              </Text>
            </FormControl>
          )}

          {/* {scData.scMinPassEnabled === 'true' || scData.scDistinctionEnabled === 'true' && isScoreWiseCongrats && ( */}
          {hasScoreLogic && congratsMode === 'ScoreWise' && (
            <Box mt="30px">

              {scData.scMinPassEnabled === 'true' && (
                <FormControl mb="20px">
                  <FormLabel fontSize="sm" fontWeight="bold">
                    For less than minimum score
                  </FormLabel>
                  <TextField
                    placeholder="eg. You can do better..."
                    maxLength={80}
                    value={scData.scCongratsBelowMin ?? ''}
                    onChange={(e: any) =>
                      handleSCChange('scCongratsBelowMin', e.target.value)
                    }
                  />
                </FormControl>
              )}

              {(scData.scMinPassEnabled === 'true' ||
                scData.scDistinctionEnabled === 'true') && (
                  <FormControl mb="20px">
                    <FormLabel fontSize="sm" fontWeight="bold">
                      For more than minimum score
                    </FormLabel>
                    <TextField
                      placeholder="eg. Great job!"
                      maxLength={80}
                      value={scData.scCongratsAboveMin ?? ''}
                      onChange={(e: any) =>
                        handleSCChange('scCongratsAboveMin', e.target.value)
                      }
                    />
                  </FormControl>
                )}

              {scData.scDistinctionEnabled === 'true' && (
                <FormControl>
                  <FormLabel fontSize="sm" fontWeight="bold">
                    For above distinction score
                  </FormLabel>
                  <TextField
                    placeholder="eg. Outstanding performance!"
                    maxLength={80}
                    value={scData.scCongratsAboveDistinction ?? ''}
                    onChange={(e: any) =>
                      handleSCChange('scCongratsAboveDistinction', e.target.value)
                    }
                  />
                </FormControl>
              )}

            </Box>
          )}

        </Box>

        <Box
          className="navigation-icon"
          // h={'100%'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          mr={'40px'}
          width={'auto'}
        >
          <Flex>
            <Box>
              <Tooltip hasArrow label="Add Navigations">
                <div>
                  <Menu
                    tabState={'leadDialog'}
                    id={seq.input}
                    for={`ScenarioCompletion${seq.input}`}
                    setNavigation={setNavigation}
                    handleBlock={handleBlock}
                    items={items}
                    seq={seq}
                  />
                </div>
              </Tooltip>
            </Box>

            <Box
              ml={'4px'}
              cursor={'pointer'}
              display={
                input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow
                  ? 'block'
                  : 'none'
              }
              zIndex={9999}
            >
              {input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow ===
                'New Block' &&
                !input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionnavigate ? (
                // Render content for New Block
                <>
                  <MiniBox1 seq={seq} i={index} />
                </>
              ) : input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionleadShow ===
                'Select Block' &&
                !input?.[`ScenarioCompletion${seq.input}`]?.ScenarioCompletionnavigate ? (
                // Render select tag for Select Block
                <Select
                  placeholder={'Blocks...'}
                  id="Dialog"
                  name={`ScenarioCompletion${seq.input}`}
                  menuPortalTarget={document.body}
                  styles={customStyles}
                  options={showSelectBlock.filter(
                    (option: any) => option.value !== seq.input,
                  )}
                  isSearchable={true}
                  className="react-select"
                  value={
                    showSelectBlock.find(
                      (option: any) =>
                        option.value ==
                        input?.[`ScenarioCompletion${seq.input}`]
                          ?.ScenarioCompletionnavigate,
                    ) || null
                  }
                  onChange={(e: any) =>
                    handleSelectBlock(
                      e,
                      seq.input,
                      `ScenarioCompletion${seq.input}`,
                      `ScenarioCompletion${seq.input}`,
                    )
                  }
                />
              ) : (
                // Render content for the 'else' condition
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <StrightConector
                      name={
                        input?.[`ScenarioCompletion${seq.input}`]
                          ?.ScenarioCompletionleadShow === 'New Block'
                          ? showSelectBlock.find(
                            (option: any) =>
                              option.value ==
                              input?.[`ScenarioCompletion${seq.input}`]
                                ?.ScenarioCompletionnavigate,
                          )?.label
                          : input?.[`ScenarioCompletion${seq.input}`]
                            ?.ScenarioCompletionleadShow === 'Select Block'
                            ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`ScenarioCompletion${seq.input}`]
                                  ?.ScenarioCompletionnavigate,
                            )?.label
                            : input?.[`ScenarioCompletion${seq.input}`]
                              ?.ScenarioCompletionnavigate
                      }
                    />
                  </div>
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default ScenarioCompletionCompo;


